import { styles, variants, MenuItemTheme } from '../MenuItemStyles.css';
import { baseTheme } from './MenuItemBaseTheme.css';
import { multiVariantStyles } from './MenuItemVariants.css';

const MenuItemStableTheme: MenuItemTheme = {
  baseTheme,
  multiVariantStyles,
  variants,
  styles
};

export { MenuItemStableTheme };
